import React from "react";
import {safeHTML} from "../../utils/safeHTML";
import styles from "./SocialBlock.module.scss";
import SocialBlockItem from "./SocialBlockItem";


const SocialBlock = React.forwardRef(
  function SocialBlock({title, list}, ref) {
    const items = list?.map((item, index) => <SocialBlockItem {...item} key={`item-${index}`}/>);
    return (
      <div className={styles.socialBlock} ref={ref}>
        <div className={styles.socialBlock__title}>{safeHTML(title)}</div>
        <div className={styles.socialBlock__list}>{items}</div>
      </div>
    );
  });
export default SocialBlock;
SocialBlock.propTypes = {};

